import { c as _c } from "react/compiler-runtime";
import { Heading, Picture } from '@petsmart-ui/sparky';
import cn from 'classnames';
import { cutText } from '../../utils/cutText';
import { propsImageItems } from '../../utils/propsImagesItems';
import type { CampaignHeroVariantProps } from './types';
import './CampaignHeroMd.scss';
export default function CampaignHeroMd(t0) {
  const $ = _c(18);
  const {
    header,
    image,
    primaryTextColor,
    isH1
  } = t0;
  let t1;
  if ($[0] !== image) {
    t1 = propsImageItems(image);
    $[0] = image;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const imageItems = t1;
  const t2 = primaryTextColor === "Dark Grey";
  const t3 = primaryTextColor === "Dark Grey w/ Red";
  let t4;
  if ($[2] !== t2 || $[3] !== t3) {
    t4 = cn("campaign-hero-md", {
      "campaign-hero-md__grey": t2,
      "campaign-hero-md__red": t3
    });
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const t5 = imageItems[0]?.srcSet;
  let t6;
  if ($[5] !== image.webAltText || $[6] !== imageItems || $[7] !== t5) {
    t6 = <Picture imgAlt={image.webAltText} imgSrc={t5} items={imageItems} />;
    $[5] = image.webAltText;
    $[6] = imageItems;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const t7 = isH1 ? "h1" : "h2";
  let t8;
  if ($[9] !== header) {
    t8 = cutText(header, 20);
    $[9] = header;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== t7 || $[12] !== t8) {
    t9 = <Heading tagName={t7}>{t8}</Heading>;
    $[11] = t7;
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== t4 || $[15] !== t6 || $[16] !== t9) {
    t10 = <div className={t4}>{t6}{t9}</div>;
    $[14] = t4;
    $[15] = t6;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  return t10;
}